import React, { useContext, useEffect, useState } from "react";
import { LayoutContext, SCREENTYPE } from "@/hooks/useLayout";
import { Contenu } from "@/types/contenu";
import { PUB_EVERY_X, PUB_START_INDEX, withPubEveryX } from "@/configs/pub";

import Carte from "./carte";

import styles from "./cartes.module.scss";

type PropTypes = {
    contenus: Contenu[];
};

const Cartes = ({ contenus }: PropTypes) => {
    const { screenType } = useContext(LayoutContext);
    const [isMobile, setIsMobile] = useState(true);
    const pubEveryX = isMobile ? PUB_EVERY_X.CARTES_MOBILE : PUB_EVERY_X.CARTES_DESKTOP;
    const contenusWithPub = withPubEveryX(contenus, pubEveryX, PUB_START_INDEX.CARTES);

    useEffect(() => {
        setIsMobile(screenType == SCREENTYPE.MOBILE);
    }, []);

    return (
        <div data-component="Cartes" className={styles.me}>
            {contenusWithPub.map((contenu) => {
                const { id } = contenu;

                return <Carte key={id} contenu={contenu} />;
            })}
        </div>
    );
};

export default Cartes;
